import { useRef, useState, useEffect } from 'react';

export const useIntersectionObserver = (
  ref: React.RefObject<Element | null>,
  options: IntersectionObserverInit
) => {
  const [inViewport, setInViewport] = useState(false);
  const optionsRef = useRef(options);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInViewport(entry.isIntersecting),
      optionsRef.current
    );

    const currentRef = ref.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return inViewport;
};
